mutation CommunicationChannelUpdate(
  $input: CommunicationChannelUpdateInput!
) {
  communicationChannelUpdate(input: $input) {
    communicationChannels {
      id
      name
      description
      isMessages
      isReports
      _rowTimestamp
      _isUpdatable
      _isDeletable
      _createdDate
    }
  }
}
